export const ENDPOINTS = {
    SEARCH_AI_ENDPOINT: `${window.ai_search_api_url}`,
    AUTHENTICATE_AI_ENDPOINT: `${window.ai_authenticate_api_url}`,
    SEARCH_ALL_ENDPOINT: `${window.location.origin}/esearch/all`,
    SEARCH_TOPICS_ENDPOINT: `${window.location.origin}/esearch/topics`,
    SEARCH_IMAGES_ENDPOINT: `${window.location.origin}/esearch/images`,
    SEARCH_DOCUMENTS_ENDPOINT: `${window.location.origin}/esearch/documents`,
    SEARCH_AI_DIAGNOSIS_ENDPOINT: `${window.location.origin}/aisearch/diagnosis`,

    FETCH_NOTIFICATIONS_ENDPOINT: `${window.location.origin}/notifications-api/get`,
    UPDATE_NOTIFICATIONS_ENDPOINT: `${window.location.origin}/notifications-api/update`,

    FETCH_CONTEXTUAL_CONTENT: `${window.location.origin}/snippetsearch/topicMenuTitle`,

    FETCH_COMPLETED_INDUCTION_STEPS: `${window.location.origin}/member-api/get-onboarding-steps`,
    COMPLETE_INDUCTION_STEP: `${window.location.origin}/member-api/complete-onboarding-step`,
    ADD_FAVOURITES: `${window.location.origin}/keeps/add_favourite_topics`,

    SHARE_RESOURCE: `${window.location.origin}/patientresources-api/share`,


};